import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA040_Request,
  IAPI_STA040_Response,
} from "../../../type/apiType";

// 源泉徴収票更新API
const httpIAPI_STA040 = async (
  param: IAPI_STA040_Request
): Promise<IAPI_STA040_Response> => {
  let res = await http.post(ApiUrl.API_STA040, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_STA040 };
